import { companyClientStatusLabels } from '@/modules/companies/clientStatus';
import type { CompanyClientStatusApi } from '@/modules/companies/types';
import { Badge } from '@/modules/ui/components/badge/Badge';

interface CompanyClientStatusBadgeProps {
  status: CompanyClientStatusApi;
}

const statusClassNames: Record<CompanyClientStatusApi, string> = {
  Prospect: 'border-primary-700 bg-secondary-150 text-primary-700',
  Active: 'border-semantic-560 bg-semantic-560/10 text-foreground',
  Inactive: 'border-neutral-400 bg-neutral-300 text-foreground',
};

export function CompanyClientStatusBadge({
  status,
}: CompanyClientStatusBadgeProps) {
  return (
    <Badge variant="outline" size="sm" className={statusClassNames[status]}>
      {companyClientStatusLabels[status]}
    </Badge>
  );
}
